import mapFunction from './mapResources';

export default  mapFunction('tool_states', {
    isFetching: false,
    items: [] 
});